/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import BidiWarning from '@atlaskit/code'` instead.
 */
export { default } from './ui';
